"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorEventType = void 0;
var SensorEventType;
(function (SensorEventType) {
    SensorEventType["Version"] = "VERSION";
    SensorEventType["ACK"] = "ACK";
    SensorEventType["Data"] = "DATA";
    SensorEventType["Alarm"] = "ALARM";
    SensorEventType["Location"] = "LOCATION";
    SensorEventType["Type"] = "TYPE";
    SensorEventType["Battery"] = "BATTERY";
    SensorEventType["DataPeriod"] = "DATA_PERIOD";
    SensorEventType["Unknown"] = "UNKNOWN";
})(SensorEventType = exports.SensorEventType || (exports.SensorEventType = {}));
